import { Vue } from './hook'
import App from './App'
import router from './router'
import store from './store'
import $utils from '../src/assets/js/utils'

import maiaUI from '@longfor/maia-ui'
import ElementUI from 'element-ui'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)
import { MessageBox } from 'mint-ui';
Vue.prototype.$MessageBox = MessageBox
import 'element-ui/lib/theme-chalk/index.css'
// longfor pc端组件-zyd-start
import '@longfor/maia-ui/src/assets/element-ui/index.css'   //element-ui引入该样式
import '@longfor/maia-ui/dist/styles/maia.css'   // 引入亮色主题样式
import "@/assets/css/maia.styl"
import common from "@/assets/js/common";
Vue.use(maiaUI)
// longfor pc端组件-zyd-end
import VConsole from 'vconsole/dist/vconsole.min.js'
// 访问todo页面秘钥  md5
const seeTodoKey = "5acdbdb807fe764c0184b1b93ec96f34"

// import "@longfor/ma-icon"
// 导航前置守卫
router.beforeEach((to,from,next)=>{

  if(to.name=='iframeForm'){
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
  // 从以下路由跳出时,强制转换成竖屏
  if((from.name=='iframeForm'||from.name=='processInfo'||from.name=='readingLog'||from.name=='circleRecord')&&(to.name!='iframeForm'&&to.name!='processInfo'&&to.name!='readingLog'&&to.name!='circleRecord')){
    if(!$utils.isPC()){
      // 转成竖屏
      common.$createIfm('rotateScreen','orientation=1')
    }
  }
  // 从以下路由跳往指定路由时--刷新
  if(from.name=='check'||from.name=='selectPerson'){
    if(to.name=='processInfo' || to.name=='iframeForm' || to.name=='readingLog'){
      setTimeout(() => {
        window.location.reload()
      }, 1)}
    next()
  }else{
    next()
  }
});

if (!$utils.isPC()) {
  // 按需引入rem
  require('../src/assets/js/rem')
}

import toastRegistry from './assets/tiptoast/index'
Vue.use(toastRegistry)


Vue.use(ElementUI)
var infiniteScroll = require('vue-infinite-scroll');
Vue.use(infiniteScroll)

import maiaH5 from "@longfor/maia-h5";
Vue.use(maiaH5)
// 开发环境按需使用MOCK数据
// process.env.MOCK && require('@/mock')
Vue.directive('preventReClick', {
  inserted (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
})

// im-交圈记录（群聊消息）组件接入
import YtsImMsg from '../static/imLib/yts-im-msg-1.0.2'
Vue.use(YtsImMsg);

console.log('Pipeline migration test')

// 创建根实例
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
    created () {
      this.$store.state.urlParam = this.$utils.getUrlParam()
      this.$store.state.isPc = this.$utils.isPC()
    },
  watch: {
    $route: {
      handler: function () {
        if (!$utils.isPC()) {
          // 是否在预生产、生产环境开启vconsole,拿到移动端审批流url后，如果拼接参数showVconsole=1则展示vconsole
          const isInTestEnv =
            window.location.host.indexOf("dev") > -1 ||
            window.location.host.indexOf("sit") > -1 ||
            window.location.host.indexOf("uat") > -1;
          const {showVConsole} = this.$route.query;
          if (isInTestEnv || showVConsole === '1') {
            console.log('初始化VConsole');
            var vConsole = new VConsole();
          }
        }
      },
      deep: true,
    }
  },
})



// WEBPACK FOOTER //
// ./src/main.js